// extracted by mini-css-extract-plugin
module.exports = {"button":"StartButton_button__uy0DW"};